// extracted by mini-css-extract-plugin
export default {"addToCartControl":"JY-z","giftCard":"KY-z","btnContainer":"LY-z","cartButton":"MY-z","disabled":"NY-z"};